import React from "react";
import BoxLoader from "../../../../general/boxLoader";
import EmptyBox from "../../../../general/emptyBox";
import PatientVitalCardsBoxItem from "./patientVitalCardsBox_Item";

type PatientVitalsCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean;
  readonly?: boolean;
}

const PatientVitalCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting,
  readonly = false
}: PatientVitalsCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <PatientVitalCardsBoxItem item={item} dataListTitles={dataListTitles} key={i} readonly={readonly}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default PatientVitalCardsBox;